import { Injectable } from '@angular/core';
import type { SweetAlertOptions } from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  constructor() {

  }

  // sweetalert2 (about 78 KB) is only needed once an alert is shown, so it is loaded on first use instead of with every page.
  private async fire(options: SweetAlertOptions) {
    const { default: Swal } = await import('sweetalert2');
    return Swal.fire(options);
  }

  showNotification(status: any, title: string, duration?: number): void {
    this.fire({
      position: "top-end",
      icon: status,
      title: title,
      showConfirmButton: true,
      timer: duration ? duration : undefined
    }).catch(() => {});
  }
  showConfirmNotification(title:string,text:string,confirmText:string):Promise<boolean>{
    return this.fire({
      title: title,
      text: text,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: confirmText
    }).then((result) => {
      return result.isConfirmed;
    }).catch(() => false);
  }
  errorNotification(errorMsg?:string):void{
    this.fire({
      position: "top-end",
      icon: "error",
      title: errorMsg || "Something went wrong",
      showConfirmButton: false,
      timer: 1500
    }).catch(() => {});
  }

}
